"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/icons.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

/* Stroke icons for Forms, on the inbox list's grid: 24px, 1.75 stroke,
 * coloured by currentColor. */
const makeIcon = (paths) => {
  const Icon = ({ size = 16 }) => (
    _react2.default.createElement('svg', {
      width: size,
      height: size,
      viewBox: "0 0 24 24"   ,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.75",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      'aria-hidden': "true",
      focusable: "false", __self: this, __source: {fileName: _jsxFileName, lineNumber: 7}}

      ,  paths 
    )
  )
  return Icon
}

 const FormsIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('rect', { x: "5", y: "3", width: "14", height: "18", rx: "2", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}} )
  , _react2.default.createElement('path', { d: "M9 8h6M9 12h6M9 16h4"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}} )
)); exports.FormsIcon = FormsIcon

 const UploadIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('path', { d: "M12 15V4M7.5 8.5 12 4l4.5 4.5"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}} )
  , _react2.default.createElement('path', { d: "M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"            , __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}} )
)); exports.UploadIcon = UploadIcon

 const CameraIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('path', { d: "M4 8a2 2 0 0 1 2-2h2l1.5-2h5L16 6h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"                      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}} )
  , _react2.default.createElement('circle', { cx: "12", cy: "13", r: "3.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}} )
)); exports.CameraIcon = CameraIcon

 const ChevronDownIcon = makeIcon(_react2.default.createElement('path', { d: "m6 9 6 6 6-6"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}} )); exports.ChevronDownIcon = ChevronDownIcon

 const ChevronLeftIcon = makeIcon(_react2.default.createElement('path', { d: "m15 6-6 6 6 6"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}} )); exports.ChevronLeftIcon = ChevronLeftIcon

 const CheckIcon = makeIcon(_react2.default.createElement('path', { d: "m5 12.5 4.5 4.5L19 7.5"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}} )); exports.CheckIcon = CheckIcon

 const ClockIcon = makeIcon(_react2.default.createElement(_react2.default.Fragment, null
  , _react2.default.createElement('circle', { cx: "12", cy: "12", r: "8.5", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}} )
  , _react2.default.createElement('path', { d: "M12 7.5V12l3 2"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}} )
)); exports.ClockIcon = ClockIcon

 const PencilIcon = makeIcon(_react2.default.createElement('path', { d: "M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}} )); exports.PencilIcon = PencilIcon
